import React, { useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { searchOrgs } from '../../api/services/orgs';
import { Org } from '../../api/services/orgs/orgs.schema';
import { SearchContainer } from './OrgDetails.styles';

interface OrgSearchInputProps {
  onSelect: (orgId: number) => void;
  onClear: () => void;
  selectedOrgName?: string;
}

export const OrgSearchInput = ({
  onSelect,
  onClear,
  selectedOrgName,
}: OrgSearchInputProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<Org[]>([]);

  const handleSearch = async (query: string) => {
    setIsLoading(true);
    try {
      const result = await searchOrgs(query);
      setOptions(result);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (selected: Org[]) => {
    if (selected.length === 0) {
      onClear();
    } else {
      onSelect(selected[0].id);
    }
  };

  return (
    <SearchContainer>
      <AsyncTypeahead
        id="org-search"
        isLoading={isLoading}
        minLength={2}
        onSearch={handleSearch}
        options={options}
        labelKey="name"
        placeholder="Search organizations..."
        onChange={handleChange}
        defaultInputValue={selectedOrgName ?? ''}
      />
    </SearchContainer>
  );
};
